import axios from 'axios'

const StudentAppointmentService = {
  async getAvailableSlots (params = {}) {
    return axios.get('student/appointments/available-slots', { params })
  },

  async book (data) {
    return axios.post('student/appointments/book', data)
  },

  async getMyAppointments (params = {}) {
    return axios.get('student/appointments/my-appointments', { params })
  },

  async update (id, data) {
    return axios.put(`student/appointments/${id}`, data)
  },

  async cancel (id) {
    return axios.patch(`student/appointments/${id}/cancel`)
  }
}

export default StudentAppointmentService
